import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoObjectTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoObjectTypeModel._instance == null) GeoObjectTypeModel._instance = new GeoObjectTypeModel(authManager);
        return GeoObjectTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-object-types', 'model-sections/geo-object-types/codelist');

        this.entityName = 'model-sections.GeoObjectType';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Object Type';
        this.setLabel = 'Object Types';

        this.browser = {
            name: 'default-model-sections-geoobjecttype-browser',
            moduleName: 'default-model-sections-geoobjecttype-browser',
            moduleTitle: 'Object Types',
            moduleStateSlotName: 'default-model-sections-geoobjecttype-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoobjecttype-editor',
            moduleName: 'default-model-sections-geoobjecttype-editor',
            moduleTitle: 'Object Type',
            moduleStateSlotName: 'default-model-sections-geoobjecttype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'objectKindId',
                type: 'GeoObjectKind',
                persistent: true,
                label: 'Object Kind',
            },
        ];

    }

}
